import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Grid,
  Button,
  IconButton,
  Typography,
  Box,
  alpha,
  InputLabel,
} from "@mui/material";

import { Close, Save, AttachMoney } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import axiosInstance from "../../../services/axiosInstance";

const RevenueFormModal = ({ open, onClose, onSubmit, editData }) => {
  const { id } = useParams();
  const [companyName, setCompanyName] = useState("");

  const addedBy = localStorage.getItem("adminId");

  const [formData, setFormData] = useState({
    userId: id || "",
    paymentDate: "",
    amount: "",
    notes: "",
    currency: "INR",
    addedBy,
  });

  // Auto-fill data when editing
  useEffect(() => {
    if (editData) {
      setFormData({
        userId: editData.user?._id || editData.user,
        paymentDate: editData.paymentDate,
        amount: editData.amount,
        notes: editData.notes,
        currency: editData.currency,
        addedBy,
      });
    } else if (open) {
      setFormData({
        userId: id || "",
        paymentDate: "",
        amount: "",
        notes: "",
        currency: "INR",
        addedBy,
      });
    }
  }, [editData, open, id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  useEffect(() => {
    getUserDetails();
  }, []);

  const getUserDetails = async () => {
    try {
      const res = await axiosInstance.get(`${apiEndPointsConfig.singlLead}/${id}`);

      setCompanyName(res?.data?.data?.companyName || "");
    } catch (error) {
      console.error("Error fetching lead details:", error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pb: 2,
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
              mr: 2,
            }}
          >
            <AttachMoney color="primary" />
          </Box>

          <Box>
            <Typography variant="h6" fontWeight={600}>
              {editData ? "Edit Revenue Entry" : "Add New Revenue"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {editData
                ? "Update existing revenue information"
                : "Enter revenue details"}
            </Typography>
          </Box>
        </Box>

        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent sx={{ pt: 3 }}>
          <Grid container spacing={3}>
            {/* Company Name */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Company Name"
                value={companyName}
                disabled
              />
            </Grid>

            {/* Payment Date */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Payment Date"
                type="date"
                value={formData.paymentDate}
                onChange={(e) =>
                  setFormData({ ...formData, paymentDate: e.target.value })
                }
                required
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            {/* Amount */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Amount"
                type="number"
                value={formData.amount}
                onChange={(e) =>
                  setFormData({ ...formData, amount: e.target.value })
                }
                required
              />
            </Grid>

            {/* Currency */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Currency</InputLabel>
                <Select
                  value={formData.currency}
                  onChange={(e) =>
                    setFormData({ ...formData, currency: e.target.value })
                  }
                  label="Currency"
                >
                  <MenuItem value="INR">INR - Indian Rupee</MenuItem>
                  <MenuItem value="AED">AED - UAE Dirham</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Notes */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Notes"
                value={formData.notes}
                onChange={(e) =>
                  setFormData({ ...formData, notes: e.target.value })
                }
                multiline
                rows={3}
                placeholder="Add notes..."
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button onClick={onClose} variant="outlined">
            Cancel
          </Button>
          <Button type="submit" variant="contained" startIcon={<Save />}>
            {editData ? "Update Revenue" : "Save Revenue"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default RevenueFormModal;
